// extracted by css-extract-rspack-plugin
export default {"spaceMedium":"20px","wrapper":"lat-notification__wrapper___mNDG7"};